// Tabs.tsx
import React, { useEffect, useState } from "react";
import EventLogTable from "../../common/Searchbar/EventLogTable";
import dayjs, { Dayjs } from 'dayjs';

type SetTabPageFunction = React.Dispatch<React.SetStateAction<string>>

interface TabsProps {
    eventData?: any[];
    setTabDivHeight: SetTabPageFunction;
    addedRows: any[];
    setAddedRows: React.Dispatch<React.SetStateAction<any[]>>;
    editedComments: {};
    setEditedComments: React.Dispatch<React.SetStateAction<{}>>;
    isToggle?: boolean;
    selectedOption: string;
    setSelectedOption: React.Dispatch<React.SetStateAction<string>>
    selectedRange: {
        start: Dayjs | null;
        end: Dayjs | null;
    };
    setSelectedRange: React.Dispatch<React.SetStateAction<{
        start: Dayjs | null;
        end: Dayjs | null;
    }>>;
    setClickApply: React.Dispatch<React.SetStateAction<boolean>>;
    showEventDataMessage: boolean;
}

const EventLogForm: React.FC<TabsProps> = ({ setTabDivHeight, eventData, addedRows, setAddedRows, editedComments, setEditedComments, selectedOption, setSelectedOption, selectedRange, setSelectedRange, setClickApply, showEventDataMessage }) => {

    return (
        <div className="flex flex-col w-full">
            <div className="text-Darkmode-700 p-3">
                <EventLogTable tableData={eventData} setTabDivHeight={setTabDivHeight} addedRows={addedRows} setAddedRows={setAddedRows} editedComments={editedComments} setEditedComments={setEditedComments} isToggle selectedOption={selectedOption} setSelectedOption={setSelectedOption} selectedRange={selectedRange} setSelectedRange={setSelectedRange} setClickApply={setClickApply} showEventDataMessage={showEventDataMessage} />
            </div>
        </div>
    );
};

export default EventLogForm;
